var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({staticClass:"ib-chip",class:{ 'ib-chip--tonal': _vm.tonal, 'ib-chip--dark': _vm.$isDark },style:({
    '--h': _vm.hsl.h,
    '--s': _vm.hsl.s + '%',
    '--l': _vm.hsl.l + '%'
}),attrs:{"color":_vm.color}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }